import {
    FORMEDIT_CHOOSE_CURRENT_FORM,
} from './constants';
  
export function chooseCurrentForm(modal) {
    return {
      type: FORMEDIT_CHOOSE_CURRENT_FORM,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case FORMEDIT_CHOOSE_CURRENT_FORM:
        return {
          ...state,
          currentForm:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/formedit/redux/chooseCurrentForm.js